// extracted by mini-css-extract-plugin
export default {"progressVisualFull":"progressVisualFull__3AQkB","progressVisualPart":"progressVisualPart__UiVJE","ideaSubmitted":"ideaSubmitted__I5US-"};